import { UrlMappings } from "./constants/url-mappings";
import { attachScriptToHTML } from "./utilities/insert-js-module";
var CoveoAnalyticsController = /** @class */ (function () {
    function CoveoAnalyticsController($scope) {
        var _this = this;
        this.$scope = $scope;
        var contentType = this.getContentType();
        if (contentType === "Unknown" /* Unknown */) {
            return;
        }
        var clickableUri = this.getClickableUri(contentType);
        attachScriptToHTML(this.$scope.coveoUserAnalyticsUrl, "text/javascript" /* Text */, function () {
            var viewEventAnalyticScript = _this.buildViewEventsAnalyticScript(contentType, clickableUri, _this.$scope.authorizedUserEmail);
            attachScriptToHTML(viewEventAnalyticScript, "module" /* Module */);
        });
    }
    CoveoAnalyticsController.prototype.buildViewEventsAnalyticScript = function (contentType, clickableUrl, authorizedUserEmail) {
        var _a = this.$scope, accessToken = _a.accessToken, organizationId = _a.organizationId;
        var isUserAuthorized = !!authorizedUserEmail;
        var customDataScript = isUserAuthorized
            ? "coveoua('set', 'customData', { context_user_email: '" + authorizedUserEmail + "' });\n"
            : '';
        var analyticScript = "\n            " + customDataScript + "\n            coveoua('init', '" + accessToken + "', '" + organizationId + "');\n            coveoua('send', 'view', {\n                contentIdKey: '@clickableuri',\n                contentIdValue: '" + clickableUrl + "',\n                contentType: '" + contentType + "',\n                location: '" + clickableUrl + "'\n            });\n        ";
        return analyticScript;
    };
    CoveoAnalyticsController.prototype.getContentType = function () {
        var currentURL = window.location.href;
        for (var _i = 0, UrlMappings_1 = UrlMappings; _i < UrlMappings_1.length; _i++) {
            var _a = UrlMappings_1[_i], urlFragment = _a[0], contentType = _a[1];
            if (currentURL.includes(urlFragment)) {
                return contentType;
            }
        }
        return "Unknown" /* Unknown */;
    };
    CoveoAnalyticsController.prototype.getClickableUri = function (contentType) {
        var currentURL = window.location.href;
        var commonContentTypesArray = [
            "Jabra Glossary" /* JabraGlossary */, "Hearing Protection" /* HearingProtection */, "Technical Whitepapers" /* TechnicalWhitepapers */,
            "Warranty Terms" /* WarrantyTerms */, "Release Notes" /* ReleaseNotes */, "Product Support Page" /* ProductSupportPage */,
            "Product Catalog" /* ProductCatalog */, "FAQ" /* FAQ */, "YouTube Video" /* Video */
        ];
        if (commonContentTypesArray.indexOf(contentType) >= 0) {
            return currentURL.replace(/##.*/, '');
        }
        return '';
    };
    CoveoAnalyticsController.$inject = ['$scope'];
    return CoveoAnalyticsController;
}());
export var CoveoAnalyticsDirective = [
    function () {
        return {
            controller: CoveoAnalyticsController,
            restrict: 'E',
            scope: {
                accessToken: '@',
                organizationId: '@',
                coveoUserAnalyticsUrl: '@',
                authorizedUserEmail: '@',
            }
        };
    },
];
